import { Droppable } from "react-beautiful-dnd";
import memoizeOne from "memoize-one";
import ScenesWithoutDayScene from "./scenes-without-days-scene";

const ScenesWithoutDays = (props) => {
    const { scenes, readOnly, toggleSelectionInGroup, multiSelectTo, toggleSelection, draggingSceneId, selectedSceneIds, colorCode } = props;

    type SceneIdMap = {
        [sceneId: string]: true;
    };

    const getSelectedMap = memoizeOne((selectedSceneIds: string[]) =>
        selectedSceneIds.reduce(
            (previous: SceneIdMap, current: string): SceneIdMap => {
                previous[current] = true;
                return previous;
            },
            {}
        )
    );

    return (
        <div className="sticky">
            <table className="table">
                <thead>
                    <tr>
                        <th>Scenes without days</th>
                    </tr>
                </thead>

                <Droppable droppableId={"newScene"} type="scene">
                    {(provided, snapshot) => (
                        <tbody  {...provided.droppableProps}
                            ref={provided.innerRef}>
                            {(scenes || []).map((scene, index) => {
                                const selectionMap = getSelectedMap(
                                    selectedSceneIds || []
                                );
                                const isSelected = selectionMap
                                    ? selectionMap[scene.sceneId]
                                    : false;
                                const isGhosting =
                                    isSelected &&
                                    draggingSceneId &&
                                    draggingSceneId !== scene.sceneId;

                                return (
                                    <ScenesWithoutDayScene scene={scene}
                                        index={index}
                                        readOnly={readOnly}
                                        toggleSelectionInGroup={toggleSelectionInGroup}
                                        multiSelectTo={multiSelectTo}
                                        toggleSelection={toggleSelection}
                                        selectedSceneIds={selectedSceneIds}
                                        draggingSceneId={draggingSceneId}
                                        isSelected={isSelected}
                                        isGhosting={isGhosting}
                                        colorCode={colorCode} />
                                )
                            }
                            )}
                            {provided.placeholder}
                        </tbody>)}
                </Droppable>
            </table>
        </div>
    )
}

export default ScenesWithoutDays;